import { useState } from 'react';
import { StepChart } from './StepChart';
import { ThresholdHistory, type Editing } from './ThresholdHistory';
import { FtpSuggestion } from './ThresholdSuggestions';
import { THRESHOLD_COPY, thresholdSegments } from './thresholdModel';
import styles from './settings.module.css';

export function FtpHistoryCard({ today }: { today: string }) {
  const [editing, setEditing] = useState<Editing>(null);
  return (
    <section className={styles.ftpPanel} aria-labelledby="ftp-title">
      <header className={styles.ftpHead}>
        <div>
          <h2 id="ftp-title" className={styles.ftpTitle}>FTP HISTORY</h2>
          <p className={styles.ftpSub}>EACH RIDE USES THE FTP THAT WAS VALID ON ITS DATE</p>
        </div>
        <button type="button" className={`btn btn-pink ${styles.addFtp}`} onClick={() => setEditing({ mode: 'new' })}>+ ADD FTP</button>
      </header>
      <FtpSuggestion />
      <ThresholdHistory
        copy={THRESHOLD_COPY.ftp} today={today} editing={editing} setEditing={setEditing}
        summary={(items) => items.length > 0 && <StepChart segments={thresholdSegments(items, today, THRESHOLD_COPY.ftp)} copy={THRESHOLD_COPY.ftp} />}
      />
    </section>
  );
}
